import * as XLSX from 'xlsx'; // 엑셀 라이브러리
import { ConvertDateTimeString } from './GlobalUtility';
import { showNotification } from './Notification';

export const exportToExcel = (deviceList, startDate, endDate) => {
  // startDate와 endDate를 Date 객체로 변환
  const startDateValue = new Date(startDate);  // ref에서 value를 꺼내서 Date 객체로 변환
  const endDateValue = new Date(endDate);      // ref에서 value를 꺼내서 Date 객체로 변환

  // 날짜별로 데이터를 그룹화하기 위한 객체
  const groupedData = {};
  // ✅ 시작일 ~ 종료일 사이 날짜 배열 생성
  const dates = [];
  // ✅ 날짜 배열 생성 및 초기화
  for (let d = new Date(startDateValue); d <= endDateValue; d.setDate(d.getDate() + 1)) {
    const dateStr = new Date(d).toLocaleDateString();
    dates.push(dateStr);
    groupedData[dateStr] = {};  // 🛡️ 날짜별 객체 초기화
  }

  // deviceList에서 날짜별로 데이터를 그룹화
  deviceList.forEach(device => {
    // device.logData는 JSON 배열
    const logs = JSON.parse(device.logData); // 로그 데이터가 JSON 형식

    // 장치별로 로그를 그룹화
    logs.forEach(log => {
      const logDate = new Date(log.timestamp);  // 로그의 timestamp

      // 날짜를 YYYY-MM-DD 형식으로 변환
      const dateKey = logDate.toLocaleDateString();

      if (!groupedData[dateKey]) groupedData[dateKey] = {};
      // 해당 날짜에 장치ID별 로그 개수 추가
      if (!groupedData[dateKey][device.device_id]) {
        groupedData[dateKey][device.device_id] = { device_name: device.device_name, logCount: 0 };
      }

      groupedData[dateKey][device.device_id].logCount += 1;
    });
  });

  const devices = deviceList.map(device => device.device_id); // 장치 ID 목록

  // 엑셀 데이터 배열 초기화
  const exportData = [];

  // 첫 번째 행은 헤더 (장치명, 장치ID, 날짜별 로그 개수)
  const headerRow = ['장치명', '장치 ID', ...dates];
  exportData.push(headerRow);

  // 각 장치별로 데이터를 추가
  devices.forEach(deviceId => {
    const device = deviceList.find(device => device.device_id === deviceId);
    const row = [device.device_name, deviceId];

    dates.forEach(date => {
      // 날짜별로 장치가 있는 경우, 그 날짜의 로그 개수 추가
      const logData = groupedData[date][deviceId];
      row.push(logData ? logData.logCount : 0);
    });

    exportData.push(row);
  });

  // 엑셀 워크북 생성
  const ws = XLSX.utils.aoa_to_sheet(exportData);

  // ✅ 열 너비 설정
  ws['!cols'] = [
    { wch: 15 },  // 장치명
    { wch: 25 },  // 장치 ID
    ...dates.map(() => ({ wch: 12 })) // 날짜별 열
  ];

  // ✅ 날짜 열 포맷 적용
  dates.forEach((index) => {
    const colLetter = XLSX.utils.encode_col(index + 2); // 날짜 열 시작 위치
    for (let row = 1; row <= devices.length; row++) {
      const cellAddress = `${colLetter}${row + 1}`;
      if (ws[cellAddress]) {
        ws[cellAddress].z = '0'; // 숫자 형식 유지
      }
    }
  });

  // 엑셀 워크북 생성
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '보고서');

  const fileName = startDateValue.toLocaleDateString() === endDateValue.toLocaleDateString()
                    ? `Device_Report_${ConvertDateTimeString(startDateValue, 'YYYYMMDD')}.xlsx`
                    : `Device_Report_${ConvertDateTimeString(startDateValue, 'YYYYMMDD')}_to_${ConvertDateTimeString(endDateValue, 'YYYYMMDD')}.xlsx`

  // 엑셀 파일로 내보내기
  XLSX.writeFile(wb, fileName);
  showNotification(`내보내기 완료(${fileName})`, 'alarm', 'top-center');
};


export const exportToExcel_EER = (eeList, startDate, endDate) => {
  // startDate와 endDate를 Date 객체로 변환
  const startDateValue = new Date(startDate);  // ref에서 value를 꺼내서 Date 객체로 변환
  const endDateValue = new Date(endDate);      // ref에서 value를 꺼내서 Date 객체로 변환

  // 엑셀 데이터 배열 초기화
  const exportData = [];

  // 첫 번째 행은 헤더 (장치명, 장치ID, 날짜별 로그 개수)
  const headerRow = ['시간', '유형', '장치 이름', '출/입', '영역'];
  exportData.push(headerRow);

  eeList.forEach(entryexit => {
    const row = [entryexit.event_time, entryexit.state, entryexit.device_name, entryexit.action, entryexit.geofence_id];
    exportData.push(row);
  })

  // 엑셀 워크북 생성
  const ws = XLSX.utils.aoa_to_sheet(exportData);

  // ✅ 열 너비 설정
  ws['!cols'] = [
    { wch: 25 },  // 시간
    { wch: 10 },  // 유형
    { wch: 25 },  // 장치 이름
    { wch: 10 },  // 출/입
    { wch: 10 },  // 영역
  ];

  // 엑셀 워크북 생성
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '보고서');

  const fileName = startDateValue.toLocaleDateString() === endDateValue.toLocaleDateString()
                    ? `Device_Report_${ConvertDateTimeString(startDateValue, 'YYYYMMDD')}.xlsx`
                    : `Device_Report_${ConvertDateTimeString(startDateValue, 'YYYYMMDD')}_to_${ConvertDateTimeString(endDateValue, 'YYYYMMDD')}.xlsx`

  // 엑셀 파일로 내보내기
  XLSX.writeFile(wb, fileName);
  showNotification(`내보내기 완료(${fileName})`, 'alarm', 'top-center');
};


export const exportToExcel_SL = (slList, startDate, endDate) => {
  // startDate와 endDate를 Date 객체로 변환
  const startDateValue = new Date(startDate);  // ref에서 value를 꺼내서 Date 객체로 변환
  const endDateValue = new Date(endDate);      // ref에서 value를 꺼내서 Date 객체로 변환

  // 엑셀 데이터 배열 초기화
  const exportData = [];

  // 첫 번째 행은 헤더 (장치명, 장치ID, 날짜별 로그 개수)
  const headerRow = ['시간', '유형', '타입', '메세지', '설명'];
  exportData.push(headerRow);

  slList.forEach(systemlog => {
    const row = [systemlog.occurred_at, systemlog.type, systemlog.message, systemlog.description];
    exportData.push(row);
  })

  // 엑셀 워크북 생성
  const ws = XLSX.utils.aoa_to_sheet(exportData);

  // ✅ 열 너비 설정
  ws['!cols'] = [
    { wch: 25 },  // 시간
    { wch: 10 },  // 유형
    { wch: 10 },  // 타입
    { wch: 30 },  // 메세지
    { wch: 30 },  // 설명
  ];

  // 엑셀 워크북 생성
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '보고서');

  const fileName = startDateValue.toLocaleDateString() === endDateValue.toLocaleDateString()
                    ? `Device_Report_${ConvertDateTimeString(startDateValue, 'YYYYMMDD')}.xlsx`
                    : `Device_Report_${ConvertDateTimeString(startDateValue, 'YYYYMMDD')}_to_${ConvertDateTimeString(endDateValue, 'YYYYMMDD')}.xlsx`

  // 엑셀 파일로 내보내기
  XLSX.writeFile(wb, fileName);
  showNotification(`내보내기 완료(${fileName})`, 'alarm', 'top-center');
};


// 템플릿 미리 지정 후 적용 예시
// import * as XLSX from 'xlsx';

// const exportToExcel = async (deviceList, startDateValue, endDateValue) => {
//   // 📥 1. 템플릿 파일 로드
//   const response = await fetch('/templates/device_report_template.xlsx');
//   const arrayBuffer = await response.arrayBuffer();
//   const workbook = XLSX.read(arrayBuffer, { type: 'array' });

//   const ws = workbook.Sheets['Report']; // 템플릿의 시트 이름

//   // 📅 2. 날짜 배열 생성
//   const startDate = new Date(startDateValue);
//   const endDate = new Date(endDateValue);
//   const dateArray = [];
//   for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
//     dateArray.push(formatDate(new Date(d))); // YYYY-MM-DD 형식
//   }

//   // 🔠 3. 타이틀 업데이트 (날짜 열 추가)
//   const baseCol = 2; // "장치명" 이후 날짜 시작 열 인덱스
//   dateArray.forEach((date, index) => {
//     const cellAddress = XLSX.utils.encode_cell({ r: 0, c: baseCol + index });
//     ws[cellAddress] = { v: date, t: 's', s: ws['B1']?.s }; // 기존 스타일 복사
//   });

//   // 📝 4. 데이터 삽입
//   deviceList.forEach((device, deviceIndex) => {
//     const rowIndex = deviceIndex + 1;
//     ws[XLSX.utils.encode_cell({ r: rowIndex, c: 0 })] = { v: device.device_name, t: 's', s: ws['A2']?.s };
//     ws[XLSX.utils.encode_cell({ r: rowIndex, c: 1 })] = { v: device.device_id, t: 's', s: ws['B2']?.s };

//     dateArray.forEach((date, dateIndex) => {
//       const logs = device.logData.filter(log => formatDate(new Date(log.timestamp)) === date);
//       const logCount = logs.length;
//       ws[XLSX.utils.encode_cell({ r: rowIndex, c: baseCol + dateIndex })] = { v: logCount, t: 'n', s: ws['C2']?.s };
//     });
//   });

//   // 🔗 5. 타이틀 병합 업데이트
//   const mergeRange = {
//     s: { r: 0, c: baseCol },
//     e: { r: 0, c: baseCol + dateArray.length - 1 },
//   };
//   ws['!merges'] = ws['!merges'] || [];
//   ws['!merges'].push(mergeRange);

//   // 💾 6. 엑셀 파일 저장
//   XLSX.writeFile(workbook, `Device_Report_${formatDate(startDate)}_to_${formatDate(endDate)}.xlsx`);
// };

// const formatDate = (date) => {
//   const year = date.getFullYear();
//   const month = `${date.getMonth() + 1}`.padStart(2, '0');
//   const day = `${date.getDate()}`.padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };
